// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__51q74","newExpiryDate":"styles_newExpiryDate__rEPw8","footer":"styles_footer__2eHUi"};